/** 数据看板 */

/** 会员积分 */
// 会员积分数据概况
export const VIP_BOARD_POINT_DATA = '/ccrm2/vipBoard/point';
// 会员积分-折线图
export const VIP_BOARD_POINT_LINE_CHART = '/ccrm2/vipBoard/pointLineChart';
// 会员积分-饼图
export const VIP_BOARD_POINT_PIE_CHART = '/ccrm2/vipBoard/pointPieChart';
// 会员积分-当天明细
export const VIP_BOARD_POINT_DETAIL_BY_DATE = '/ccrm2/vipBoard/PointDetailByDate';
// 会员积分-数据明细
export const VIP_BOARD_POINT_DETAIL = '/ccrm2/vipBoard/pointDetail';

/** 会员等级 */
// 会员等级数据概况
export const VIP_BOARD_LEVEL_DATA = '/ccrm2/vipBoard/level';
// 会员等级-折线图
export const VIP_BOARD_LEVEL_LINE_CHART = '/ccrm2/vipBoard/levelLineChart';
// 会员等级-饼图
export const VIP_BOARD_LEVEL_PIE_CHART = '/ccrm2/vipBoard/levelPieChart';
// 会员等级-当天明细
export const VIP_BOARD_LEVEL_DETAIL_BY_DATE = '/ccrm2/vipBoard/levelDetailByDate';
// 会员等级-数据明细
export const VIP_BOARD_LEVEL_DETAIL = '/ccrm2/vipBoard/levelDetail';

/** 会员留存分析 */
export const VIP_BOARD_RETAIN_LIST = '/ccrm2/vipBoard/retain';

/** 会员分析 */
// 会员分析 - 数据概况
export const VIP_BOARD_USER_DATA = '/ccrm2/vipBoard/user';
// 会员分析-折线图
export const VIP_BOARD_USER_LINE_CHART = '/ccrm2/vipBoard/userLineChart';
// 会员分析-数据明细
export const VIP_BOARD_USER_DETAIL = '/ccrm2/vipBoard/userDetail';
// 会员分析 - 详情
export const VIP_BOARD_VIP_ANALYZE_DETAIL = '/ccrm2/vipBoard/vipAnalyzeDetail';

/** 来源分析 */
// 来源分析-折线图
export const VIP_BOARD_SOURCE_LINE_CHART = '/ccrm2/vipBoard/sourceLineChart';
// 来源分析-饼图
export const VIP_BOARD_SOURCE_PIE_CHART = '/ccrm2/vipBoard/sourcePieChart';
// 来源分析-数据明细
export const VIP_BOARD_SOURCE_DETAIL = '/ccrm2/vipBoard/sourceDetail';
// 来源分析-明细-折线图
export const VIP_BOARD_SOURCE_DETAIL_LINE_CHART = '/ccrm2/vipBoard/sourceDetailByLineChart';
// 来源分析-明细-数据明细
export const VIP_BOARD_SOURCE_DETAIL_BY_DETAIL = '/ccrm2/vipBoard/sourceDetailByDetail';
// 整体销售分析-导出
export const VIP_BOARD_EXPORT_SOURCE_DETAIL_BY_DETAIL = '/ccrm2/vipBoard/downloadSourceDetail';

/** 销售分析 */
// 销售分析-数据概况
export const VIP_BOARD_SALE_DATA = '/ccrm2/vipBoard/saleHeadData';
// 销售分析-数据明细/折线图
export const VIP_BOARD_SALE_LIST = '/ccrm2/vipBoard/saleDetail';
// 销售分析-整体数据明细/折线图
export const VIP_BOARD_WHOLE_SALE_LIST = '/ccrm2/vipBoard/wholeSaleDetail';
// 销售分析-导出
export const VIP_BOARD_SALE_EXPORT = '/ccrm2/vipBoard/saleDetailExport';
// 整体销售分析-导出
export const VIP_BOARD_EXPORT_WHOLE_SALE = '/ccrm2/vipBoard/exportWholeSaleData';
